//
// user.js
// Use this to write your custom JS
//



const zindex_offcanvas = 1050;
let nav_topnav = document.getElementById( 'topnav' );
let offcanvas_navbar_lg = document.getElementById( 'navbar-lg' );
offcanvas_navbar_lg.addEventListener( 'show.bs.offcanvas', function () {
  nav_topnav.style.zIndex = zindex_offcanvas + 1;
});
offcanvas_navbar_lg.addEventListener( 'hidden.bs.offcanvas', function () {
  nav_topnav.style.zIndex = 'auto';
});




(function ($) {


  
})(jQuery);
